import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getAllPageSettings, type PageSetting } from '../../lib/pages';

export const PageStatusGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [settings, setSettings] = useState<PageSetting[]>([]);
  const [loading, setLoading] = useState(true);
  const [redirecting, setRedirecting] = useState(false);

  useEffect(() => {
    const fetchSettings = async () => {
      const { data } = await getAllPageSettings();
      if (data) {
        setSettings(data);
      }
      setLoading(false);
    };
    fetchSettings();
  }, []);

  useEffect(() => {
    if (loading) return;

    // Admin panel is never blocked
    if (location.pathname.startsWith('/panel')) {
      setRedirecting(false);
      return;
    }

    // Exact path match first
    let currentSetting = settings.find((s) => s.route_path === location.pathname);

    // Then prefix match for dynamic routes (exclude root '/')
    if (!currentSetting) {
      const sortedSettings = [...settings].sort((a, b) => b.route_path.length - a.route_path.length);
      currentSetting = sortedSettings.find((s) =>
        s.route_path !== '/' && location.pathname.startsWith(s.route_path + '/')
      );
    }

    if (currentSetting && !currentSetting.is_active) {
      // Generate a random "404" path to trigger the catch-all *  */
      // route which RandomNotFoundWrapper handles
      const randomSuffix = Math.floor(Math.random() * 1000000);
      setRedirecting(true);
      navigate(`/__deactivated__/${randomSuffix}`, { replace: true });
    } else {
      setRedirecting(false);
    }
  }, [location.pathname, settings, loading]);

  if (loading || redirecting) return null;

  return <>{children}</>;
};
